import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@/shared/shared.module';

import { GolfComponent } from '@components/golf/golf/golf.component';
import { GolfTableComponent } from '@components/golf/golf/golf-table/golf-table.component';
import { GolfParticipantTournamentComponent } from '@components/golf/golf-right-col/golf-participant/golf-participant-tournament.component';
import { GolfStandingsComponent } from '@components/golf/golf-right-col/golf-standings/golf-standings.component';
import { GolfTeeTimesComponent } from '@components/golf/golf/golf-tee-times/golf-tee-times';
import { GolfBalanceComponent } from '@components/golf/golf/golf-balance/golf-balance.component';
import { GolfHoleStatisticsComponent } from '@components/golf/golf/golf-hole-statistics/golf-hole-statistics';

const GOLF_COMPONENTS = [
    GolfComponent,
    GolfTableComponent,
    GolfParticipantTournamentComponent,
    GolfStandingsComponent,
    GolfTeeTimesComponent,
    GolfBalanceComponent,
    GolfHoleStatisticsComponent,
];

@NgModule({
    declarations: GOLF_COMPONENTS,
    imports: [CommonModule, SharedModule],
    exports: GOLF_COMPONENTS,
})
export class GolfModule {}
